const fontFamilies = [
  {
    title: 'Arial',
    value: 'Arial, Helvetica, sans-serif'
  },
  {
    title: 'Bookman Old Style',
    value: '\'Bookman Old Style\', serif'
  },
  {
    title: 'Comic Sans MS',
    value: '\'Comic Sans MS\', cursive, sans-serif'
  },
  {
    title: 'Courier',
    value: 'Courier, monospace'
  },
  {
    title: 'Courier New',
    value: '\'Courier New\', Courier, monospace'
  },
  {
    title: 'Garamond',
    value: 'Garamond, serif'
  },
  {
    title: 'Georgia',
    value: 'Georgia, serif'
  },
  {
    title: 'Impact',
    value: 'Impact, Charcoal, sans-serif'
  },
  {
    title: 'Lucida Console',
    value: '\'Lucida Console\', Monaco, monospace'
  },
  {
    title: 'MS Sans Serif',
    value: '\'MS Sans Serif\', Geneva, sans-serif'
  },
  {
    title: 'MS Serif',
    value: '\'MS Serif\', \'New York\', sans-serif'
  },
  {
    title: 'Palatino Linotype',
    value: '\'Palatino Linotype\', \'Book Antiqua\', Palatino, serif'
  },
  {
    title: 'Tahoma',
    value: 'Tahoma, Geneva, sans-serif'
  },
  {
    title: 'Times New Roman',
    value: '\'Times New Roman\', Times, serif'
  },
  {
    title: 'Trebuchet MS',
    value: '\'Trebuchet MS\', Helvetica, sans-serif'
  },
  {
    title: 'Verdana',
    value: 'Verdana, Geneva, sans-serif'
  }
]

export default fontFamilies



// WEBPACK FOOTER //
// ./src/constants/toolbarEditorOptions/fontFamilies.js